import { IconProps } from '../types';

const IcScreen = (props: IconProps) => (
  <svg xmlns='http://www.w3.org/2000/svg' width='23' height='20' viewBox='0 0 23 20' fill='none' {...props}>
    <path
      d='M20.7023 0H1.88598C0.84607 0 0 0.84607 0 1.88598V15.0041C0 16.044 0.84607 16.8901 1.88598 16.8901H20.7023C21.7422 16.8901 22.5882 16.044 22.5882 15.0041V1.88598C22.5882 0.84607 21.7422 0 20.7023 0ZM21.1765 15.0041C21.1765 15.2656 20.9637 15.4783 20.7023 15.4783H1.88598C1.62452 15.4783 1.41176 15.2656 1.41176 15.0041V1.88598C1.41176 1.62452 1.62452 1.41176 1.88598 1.41176H20.7023C20.9637 1.41176 21.1765 1.62452 21.1765 1.88598V15.0041Z'
      fill={props?.fill ?? '#1D2129'}
    />
    <path
      d='M16.1378 18.5796H6.81452C6.42474 18.5796 6.10864 18.8957 6.10864 19.2855C6.10864 19.6753 6.42474 19.9914 6.81452 19.9914H16.1378C16.5276 19.9914 16.8437 19.6753 16.8437 19.2855C16.8437 18.8957 16.5276 18.5796 16.1378 18.5796Z'
      fill={props?.fill ?? '#1D2129'}
    />
  </svg>
);

export default IcScreen;
